/** @jsxImportSource @emotion/react */
import { convertNumber } from 'utils/UtMatrixUtil';

/**
 * 소수점 {digits}자리까지 표현 (소수점 {digits + 1}자리에서 반올림처리)
 * @param value
 */
const roundNumber = (value: number, digits = 1) => {
  digits = Number(digits || 1);
  if (isNaN(digits)) {
    digits = 1;
  }
  return Number((Math.round(value * 100) / 100).toFixed(digits)).toLocaleString();
};

/**
 * [Wijmo] 그리드 숫자 셀 템플릿 (값이 없는 경우 0 노출)
 * @param props
 * @constructor
 */
export const DefaultZeroNumberCellTemplate = (props, digits = 1) => {
  const value = convertNumber(props.value || 0);
  if (isNaN(value)) return 0;
  return roundNumber(value, digits);
};

/**
 * [Wijmo] 그리드 숫자 셀 템플릿 (값이 없는 경우 미노출)
 * @param props
 * @constructor
 */
export const DefaultNoneNumberCellTemplate = (props, digits = 1) => {
  if (!props.value) return '';
  const value = convertNumber(props.value || 0);
  if (isNaN(value)) return 0;
  return roundNumber(value, digits);
};
